import request from './request'

export function listLineException(data) {
  return request.post('/mes/line-exceptions/list', data)
}
export function getLineException(id) {
  return request.get('/mes/line-exceptions/' + id)
}
export function saveLineException(data) {
  return request.post('/mes/line-exceptions', data)
}
export function updateLineException(data) {
  return request.post('/mes/line-exceptions/update', data)
}
export function deleteLineException(ids) {
  return request.post('/mes/line-exceptions/delete', ids)
}
export function generateLineException(data) {
  return request.post('/mes/line-exceptions/generate', data)
}
